import { render, staticRenderFns } from "./Product-list-midify-size.vue?vue&type=template&id=a392469e&"
import script from "./Product-list-midify-size.vue?vue&type=script&lang=js&"
export * from "./Product-list-midify-size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports